/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExternalEventAllowlistEntry } from './ExternalEventAllowlistEntry';
import {
    ExternalEventAllowlistEntryFromJSON,
    ExternalEventAllowlistEntryFromJSONTyped,
    ExternalEventAllowlistEntryToJSON,
    ExternalEventAllowlistEntryToJSONTyped,
} from './ExternalEventAllowlistEntry';
import type { OWGameSteamMatch } from './OWGameSteamMatch';
import {
    OWGameSteamMatchFromJSON,
    OWGameSteamMatchFromJSONTyped,
    OWGameSteamMatchToJSON,
    OWGameSteamMatchToJSONTyped,
} from './OWGameSteamMatch';
import type { ArenaGameConfig } from './ArenaGameConfig';
import {
    ArenaGameConfigFromJSON,
    ArenaGameConfigFromJSONTyped,
    ArenaGameConfigToJSON,
    ArenaGameConfigToJSONTyped,
} from './ArenaGameConfig';
import type { OWGameSEO } from './OWGameSEO';
import {
    OWGameSEOFromJSON,
    OWGameSEOFromJSONTyped,
    OWGameSEOToJSON,
    OWGameSEOToJSONTyped,
} from './OWGameSEO';
import type { OWGameSteamData } from './OWGameSteamData';
import {
    OWGameSteamDataFromJSON,
    OWGameSteamDataFromJSONTyped,
    OWGameSteamDataToJSON,
    OWGameSteamDataToJSONTyped,
} from './OWGameSteamData';
import type { SurfaceGameConfig } from './SurfaceGameConfig';
import {
    SurfaceGameConfigFromJSON,
    SurfaceGameConfigFromJSONTyped,
    SurfaceGameConfigToJSON,
    SurfaceGameConfigToJSONTyped,
} from './SurfaceGameConfig';
import type { DataSource } from './DataSource';
import {
    DataSourceFromJSON,
    DataSourceFromJSONTyped,
    DataSourceToJSON,
    DataSourceToJSONTyped,
} from './DataSource';

/**
 * Collection contains games that has Overwolf game events support
 * @export
 * @interface OWGame
 */
export interface OWGame {
    /**
     * The Overwolf ID of the game
     * @type {string}
     * @memberof OWGame
     */
    gameId: string;
    /**
     * Discord detectable-games application id — the ID join key for Discord presence (console play).
     * @type {string}
     * @memberof OWGame
     */
    discordApplicationId?: string;
    /**
     * The title of the game
     * @type {string}
     * @memberof OWGame
     */
    name: string;
    /**
     * The description of the game.
     * @type {string}
     * @memberof OWGame
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OWGame
     */
    events: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OWGame
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGame
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGame
     */
    devourGameLogo?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGame
     */
    bannerImageSmall?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGame
     */
    bannerImageLarge?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGame
     */
    landingImageSmall?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGame
     */
    landingImageLarge?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGame
     */
    thumbnailImage?: string;
    /**
     * The image to show in the time reward breakdown
     * @type {string}
     * @memberof OWGame
     */
    timeRewardImage?: string;
    /**
     * The flag to check if the game has event support by Overwolf
     * @type {boolean}
     * @memberof OWGame
     */
    isEventSupported: boolean;
    /**
     * Sources this game is expected to produce GEP events from. Empty array + isEventSupported=true means monitor all sources. Used by Game Tracking Health monitoring to know which source/game pairs to alert on.
     * @type {Array<DataSource>}
     * @memberof OWGame
     */
    expectedSources?: Array<DataSource>;
    /**
     * When set, suppresses RED alerts for this game (e.g. acknowledged Overwolf-side regression). Cron still writes snapshots.
     * @type {string}
     * @memberof OWGame
     */
    trackingHealthSuppressionReason?: string;
    /**
     * Optional auto-clear timestamp; alerting resumes after this Unix-ms.
     * @type {number}
     * @memberof OWGame
     */
    trackingHealthSuppressedUntil?: number;
    /**
     * The flag to check if the game is supported by DevourGO
     * @type {boolean}
     * @memberof OWGame
     */
    isEventSupportReady?: boolean;
    /**
     * Whether competitions (tournaments, challenges, ladders) are supported for this game
     * @type {boolean}
     * @memberof OWGame
     */
    competitionSupported?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OWGame
     */
    hasUserStats?: boolean;
    /**
     * Steam App ID for the game
     * @type {number}
     * @memberof OWGame
     */
    steamAppId?: number;
    /**
     * SEO-friendly URL slug
     * @type {string}
     * @memberof OWGame
     */
    slug?: string;
    /**
     * Whether time tracking is enabled for this game
     * @type {boolean}
     * @memberof OWGame
     */
    timeTrackedGame?: boolean;
    /**
     * Whether this entry is a platform launcher (Battle.net, Epic, Steam, etc.). Used to suppress launcher heartbeats when a non-launcher game is the current session.
     * @type {boolean}
     * @memberof OWGame
     */
    isLauncher?: boolean;
    /**
     * 
     * @type {OWGameSEO}
     * @memberof OWGame
     */
    seo?: OWGameSEO;
    /**
     * 
     * @type {OWGameSteamMatch}
     * @memberof OWGame
     */
    steamMatch?: OWGameSteamMatch;
    /**
     * 
     * @type {OWGameSteamData}
     * @memberof OWGame
     */
    steamData?: OWGameSteamData;
    /**
     * Custom Devour game categories for carousel grouping
     * @type {Array<string>}
     * @memberof OWGame
     */
    devourCategories?: Array<string>;
    /**
     * Whether this game is available in Challenge Arena for user-created challenges
     * @type {boolean}
     * @memberof OWGame
     */
    arenaEnabled?: boolean;
    /**
     * Whether this game has event pipeline integration for automated scoring
     * @type {boolean}
     * @memberof OWGame
     */
    autoScoringCapable?: boolean;
    /**
     * External game identifier used by Blitz integration
     * @type {string}
     * @memberof OWGame
     */
    blitzGameId?: string;
    /**
     * Hex color for competition card branding (e.g.,
     * @type {string}
     * @memberof OWGame
     */
    brandColor?: string;
    /**
     * 
     * @type {ArenaGameConfig}
     * @memberof OWGame
     */
    arenaConfig?: ArenaGameConfig;
    /**
     * Whether Hub activities are enabled for this game
     * @type {boolean}
     * @memberof OWGame
     */
    hubEnabled?: boolean;
    /**
     * 
     * @type {SurfaceGameConfig}
     * @memberof OWGame
     */
    hubConfig?: SurfaceGameConfig;
    /**
     * Master toggle for Overwolf clip capture for this game
     * @type {boolean}
     * @memberof OWGame
     */
    clipEnabled?: boolean;
    /**
     * Windows exe name passed to the Overwolf recorder (e.g. VALORANT-Win64-Shipping.exe)
     * @type {string}
     * @memberof OWGame
     */
    gameProcess?: string;
    /**
     * Twitch game_id values that map to this title. Authoritative join key for "is this creator streaming this game".
     * @type {Array<string>}
     * @memberof OWGame
     */
    twitchGameIds?: Array<string>;
    /**
     * Kick category.id values that map to this title.
     * @type {Array<string>}
     * @memberof OWGame
     */
    kickCategoryIds?: Array<string>;
    /**
     * Lowercased YouTube game names — YouTube exposes no stable per-title game id.
     * @type {Array<string>}
     * @memberof OWGame
     */
    youtubeGameNames?: Array<string>;
    /**
     * Lowercased aliases matched against stream title and tag text. Weakest signal, and the only one available before a title has a platform category.
     * @type {Array<string>}
     * @memberof OWGame
     */
    streamTitleAliases?: Array<string>;
    /**
     * Events exposed to self-serve authoring for this game. Empty means the game is not self-serve-ready.
     * @type {Array<ExternalEventAllowlistEntry>}
     * @memberof OWGame
     */
    externalEventAllowlist?: Array<ExternalEventAllowlistEntry>;
    /**
     * 
     * @type {string}
     * @memberof OWGame
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof OWGame
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof OWGame
     */
    updatedAt: number;
}

/**
 * Check if a given object implements the OWGame interface.
 */
export function instanceOfOWGame(value: object): value is OWGame {
    if (!('gameId' in value) || value['gameId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('events' in value) || value['events'] === undefined) return false;
    if (!('isEventSupported' in value) || value['isEventSupported'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function OWGameFromJSON(json: any): OWGame {
    return OWGameFromJSONTyped(json, false);
}

export function OWGameFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWGame {
    if (json == null) {
        return json;
    }
    return {
        
        'gameId': json['gameId'],
        'discordApplicationId': json['discordApplicationId'] == null ? undefined : json['discordApplicationId'],
        'name': json['name'],
        'description': json['description'],
        'events': json['events'],
        'logo': json['logo'] == null ? undefined : json['logo'],
        'icon': json['icon'] == null ? undefined : json['icon'],
        'devourGameLogo': json['devourGameLogo'] == null ? undefined : json['devourGameLogo'],
        'bannerImageSmall': json['bannerImageSmall'] == null ? undefined : json['bannerImageSmall'],
        'bannerImageLarge': json['bannerImageLarge'] == null ? undefined : json['bannerImageLarge'],
        'landingImageSmall': json['landingImageSmall'] == null ? undefined : json['landingImageSmall'],
        'landingImageLarge': json['landingImageLarge'] == null ? undefined : json['landingImageLarge'],
        'thumbnailImage': json['thumbnailImage'] == null ? undefined : json['thumbnailImage'],
        'timeRewardImage': json['timeRewardImage'] == null ? undefined : json['timeRewardImage'],
        'isEventSupported': json['isEventSupported'],
        'expectedSources': json['expectedSources'] == null ? undefined : ((json['expectedSources'] as Array<any>).map(DataSourceFromJSON)),
        'trackingHealthSuppressionReason': json['trackingHealthSuppressionReason'] == null ? undefined : json['trackingHealthSuppressionReason'],
        'trackingHealthSuppressedUntil': json['trackingHealthSuppressedUntil'] == null ? undefined : json['trackingHealthSuppressedUntil'],
        'isEventSupportReady': json['isEventSupportReady'] == null ? undefined : json['isEventSupportReady'],
        'competitionSupported': json['competitionSupported'] == null ? undefined : json['competitionSupported'],
        'hasUserStats': json['hasUserStats'] == null ? undefined : json['hasUserStats'],
        'steamAppId': json['steamAppId'] == null ? undefined : json['steamAppId'],
        'slug': json['slug'] == null ? undefined : json['slug'],
        'timeTrackedGame': json['timeTrackedGame'] == null ? undefined : json['timeTrackedGame'],
        'isLauncher': json['isLauncher'] == null ? undefined : json['isLauncher'],
        'seo': json['seo'] == null ? undefined : OWGameSEOFromJSON(json['seo']),
        'steamMatch': json['steamMatch'] == null ? undefined : OWGameSteamMatchFromJSON(json['steamMatch']),
        'steamData': json['steamData'] == null ? undefined : OWGameSteamDataFromJSON(json['steamData']),
        'devourCategories': json['devourCategories'] == null ? undefined : json['devourCategories'],
        'arenaEnabled': json['arenaEnabled'] == null ? undefined : json['arenaEnabled'],
        'autoScoringCapable': json['autoScoringCapable'] == null ? undefined : json['autoScoringCapable'],
        'blitzGameId': json['blitzGameId'] == null ? undefined : json['blitzGameId'],
        'brandColor': json['brandColor'] == null ? undefined : json['brandColor'],
        'arenaConfig': json['arenaConfig'] == null ? undefined : ArenaGameConfigFromJSON(json['arenaConfig']),
        'hubEnabled': json['hubEnabled'] == null ? undefined : json['hubEnabled'],
        'hubConfig': json['hubConfig'] == null ? undefined : SurfaceGameConfigFromJSON(json['hubConfig']),
        'clipEnabled': json['clipEnabled'] == null ? undefined : json['clipEnabled'],
        'gameProcess': json['gameProcess'] == null ? undefined : json['gameProcess'],
        'twitchGameIds': json['twitchGameIds'] == null ? undefined : json['twitchGameIds'],
        'kickCategoryIds': json['kickCategoryIds'] == null ? undefined : json['kickCategoryIds'],
        'youtubeGameNames': json['youtubeGameNames'] == null ? undefined : json['youtubeGameNames'],
        'streamTitleAliases': json['streamTitleAliases'] == null ? undefined : json['streamTitleAliases'],
        'externalEventAllowlist': json['externalEventAllowlist'] == null ? undefined : ((json['externalEventAllowlist'] as Array<any>).map(ExternalEventAllowlistEntryFromJSON)),
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}

export function OWGameToJSON(json: any): OWGame {
    return OWGameToJSONTyped(json, false);
}

export function OWGameToJSONTyped(value?: OWGame | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gameId': value['gameId'],
        'discordApplicationId': value['discordApplicationId'],
        'name': value['name'],
        'description': value['description'],
        'events': value['events'],
        'logo': value['logo'],
        'icon': value['icon'],
        'devourGameLogo': value['devourGameLogo'],
        'bannerImageSmall': value['bannerImageSmall'],
        'bannerImageLarge': value['bannerImageLarge'],
        'landingImageSmall': value['landingImageSmall'],
        'landingImageLarge': value['landingImageLarge'],
        'thumbnailImage': value['thumbnailImage'],
        'timeRewardImage': value['timeRewardImage'],
        'isEventSupported': value['isEventSupported'],
        'expectedSources': value['expectedSources'] == null ? undefined : ((value['expectedSources'] as Array<any>).map(DataSourceToJSON)),
        'trackingHealthSuppressionReason': value['trackingHealthSuppressionReason'],
        'trackingHealthSuppressedUntil': value['trackingHealthSuppressedUntil'],
        'isEventSupportReady': value['isEventSupportReady'],
        'competitionSupported': value['competitionSupported'],
        'hasUserStats': value['hasUserStats'],
        'steamAppId': value['steamAppId'],
        'slug': value['slug'],
        'timeTrackedGame': value['timeTrackedGame'],
        'isLauncher': value['isLauncher'],
        'seo': OWGameSEOToJSON(value['seo']),
        'steamMatch': OWGameSteamMatchToJSON(value['steamMatch']),
        'steamData': OWGameSteamDataToJSON(value['steamData']),
        'devourCategories': value['devourCategories'],
        'arenaEnabled': value['arenaEnabled'],
        'autoScoringCapable': value['autoScoringCapable'],
        'blitzGameId': value['blitzGameId'],
        'brandColor': value['brandColor'],
        'arenaConfig': ArenaGameConfigToJSON(value['arenaConfig']),
        'hubEnabled': value['hubEnabled'],
        'hubConfig': SurfaceGameConfigToJSON(value['hubConfig']),
        'clipEnabled': value['clipEnabled'],
        'gameProcess': value['gameProcess'],
        'twitchGameIds': value['twitchGameIds'],
        'kickCategoryIds': value['kickCategoryIds'],
        'youtubeGameNames': value['youtubeGameNames'],
        'streamTitleAliases': value['streamTitleAliases'],
        'externalEventAllowlist': value['externalEventAllowlist'] == null ? undefined : ((value['externalEventAllowlist'] as Array<any>).map(ExternalEventAllowlistEntryToJSON)),
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

